import { z } from 'zod';

export const profileHighlightsTopFocusAreasModalFormSchema = z.object({
  topFocusAreas: z
    .array(z.string())
    .min(1, { message: 'Please select at least 1 focus area' })
    .max(5, { message: 'Please select no more than 5 focus areas' }),
  otherFocusAreas: z.array(z.string()),
  hiddenFocusAreas: z.array(z.string()),
});
